import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import isString from 'lodash/isString';
import { withStyles } from '@material-ui/core';
import RadioactiveIcon from 'mdi-react/RadioactiveIcon';
import AtomIcon from 'mdi-react/AtomIcon';
import DoctorIcon from 'mdi-react/DoctorIcon';
import MonitorDashboardIcon from 'mdi-react/MonitorDashboardIcon';
import LanConnectIcon from 'mdi-react/LanConnectIcon';
import AccountSupervisorCircleIcon from 'mdi-react/AccountSupervisorCircleIcon';
import HumanHandsupIcon from 'mdi-react/HumanHandsupIcon';
import BookOpenPageVariantIcon from 'mdi-react/BookOpenPageVariantIcon';
import SettingsTransferIcon from 'mdi-react/SettingsTransferIcon';
import CalendarClockIcon from 'mdi-react/CalendarClockIcon';
import ChartDonutVariantIcon from 'mdi-react/ChartDonutVariantIcon';
import { ListAlt, ExpandLess, Memory } from '@material-ui/icons';
import { EventBusService } from '../../services/event-bus.service';
import { styles } from './sidebar.styles';
var icons = {
  RadioactiveIcon: React.createElement(RadioactiveIcon, null),
  AtomIcon: React.createElement(AtomIcon, null),
  DoctorIcon: React.createElement(DoctorIcon, null),
  MonitorDashboardIcon: React.createElement(MonitorDashboardIcon, null),
  LanConnectIcon: React.createElement(LanConnectIcon, null),
  ChartDonutVariantIcon: React.createElement(ChartDonutVariantIcon, null),
  AccountSupervisorCircleIcon: React.createElement(AccountSupervisorCircleIcon, null),
  MemoryIcon: React.createElement(Memory, null),
  HumanHandsupIcon: React.createElement(HumanHandsupIcon, null),
  BookOpenPageVariantIcon: React.createElement(BookOpenPageVariantIcon, null),
  SettingsTransferIcon: React.createElement(SettingsTransferIcon, null),
  CalendarClockIcon: React.createElement(CalendarClockIcon, null)
};

var Sidebar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Sidebar, _React$Component);

  function Sidebar(props) {
    var _this;

    _classCallCheck(this, Sidebar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sidebar).call(this, props));
    /**
     * Создаем структуру меню и отсеиваем не нужные параметры
     * @param route
     */

    _this.createMenu = function (route) {
      if (route && route.routes) {
        return route.routes.filter(function (route) {
          return !route.hidden;
        }).map(function (route) {
          var result = {
            path: route.path || '',
            url: route.url || '',
            label: route.label || '',
            icon: route.icon || ''
          };

          if (route.routes && route.routes.length) {
            result.routes = _this.createMenu(route);
          }

          return result;
        });
      }

      return [];
    };
    /**
     * Получение активного элемента меню при первой загрузке страницы
     * @param route
     */


    _this.getDefaultActive = function (route) {
      if (route && route.routes) {
        return route.routes.filter(function (route) {
          return !route.hidden;
        }).filter(function (route) {
          return route.path && isString(route.path) && _this.isActive(route.path);
        }).map(function (route) {
          return route.path;
        });
      }

      return [];
    };
    /**
     * Проверка активого раздела в меню
     * @param path
     */


    _this.isActive = function (path) {
      return window.location.pathname.search(path) === 0;
    };
    /**
     * Открытие/закрытие субменю
     * @param route
     */


    _this.toggle = function (route) {
      return function () {
        var activeRoutes = _this.state.activeRoutes;
        var path = route.path;

        var newActiveRoutes = _this.state.activeRoutes.slice();

        if (activeRoutes.includes(path)) {
          newActiveRoutes.splice(activeRoutes.indexOf(path), 1);
        } else {
          newActiveRoutes.push(path);
        }

        _this.setState({
          activeRoutes: newActiveRoutes
        });
      };
    };
    /**
     * Добавляет активный элемент в список при первой загрузке модуля
     * @param path
     */


    _this.setActive = function (path) {
      return function () {
        var newActiveRoutes = _this.state.activeRoutes.slice();

        newActiveRoutes.push(path);

        _this.setState({
          activeRoutes: newActiveRoutes
        });
      };
    };

    _this.renderMenu = function (routes) {
      var classes = _this.props.classes;
      var activeRoutes = _this.state.activeRoutes;

      if (!routes) {
        return null;
      }

      return React.createElement("ul", {
        className: classes.list
      }, routes.map(function (route, index) {
        if (route.routes) {
          return React.createElement("li", {
            key: route.path,
            className: classnames(classes.item, route.hidden || !activeRoutes.includes(route.path) ? classes.hidden : '')
          }, React.createElement("div", {
            className: classes.toggle,
            onClick: _this.toggle(route)
          }, route.icon && React.createElement("div", {
            className: classes.icon
          }, _this.getIcon(route.icon)), React.createElement("div", {
            className: classes.label
          }, route.label), React.createElement(ExpandLess, {
            className: classes.caret
          })), React.createElement("div", {
            className: classes.submenu
          }, _this.renderMenu(route.routes)));
        } else {
          return React.createElement("li", {
            className: classes.item,
            key: "path-".concat(index)
          }, route.path && React.createElement(Link, {
            to: route.path,
            onClick: _this.setActive(route.path),
            className: classnames(classes.link, _this.isActive(route.path) ? classes.active : '')
          }, route.icon && React.createElement("div", {
            className: classes.icon
          }, _this.getIcon(route.icon)), React.createElement("div", {
            className: classes.label
          }, route.label)), !route.path && React.createElement("a", {
            href: route.url,
            className: classes.link,
            target: '_blank',
            rel: 'noopener noreferrer'
          }, route.icon && React.createElement("div", {
            className: classes.icon
          }, _this.getIcon(route.icon)), React.createElement("div", {
            className: classes.label
          }, route.label)));
        }
      }));
    };

    _this.state = {
      routes: _this.createMenu(props.route),
      activeRoutes: _this.getDefaultActive(props.route)
    };
    return _this;
  }

  _createClass(Sidebar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // В случае подгрузки нового модуля, необходимо перерендерить меню
      this.eventService$ = EventBusService.on('changeMenu', function () {
        _this2.setState({
          routes: _this2.createMenu(_this2.props.route),
          activeRoutes: _this2.getDefaultActive(_this2.props.route)
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.eventService$.unsubscribe();
    }
  }, {
    key: "getIcon",
    value: function getIcon(icon) {
      if (typeof icon !== 'string') {
        return icon;
      }

      if (icons[icon]) {
        return icons[icon];
      }

      return React.createElement(ListAlt, {
        fontSize: 'small'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          hide = _this$props.hide,
          version = _this$props.version;
      var routes = this.state.routes;
      return React.createElement("div", {
        className: "".concat(classes.menu, " ").concat(hide ? classes.min : '')
      }, this.renderMenu(routes), version && React.createElement("div", {
        className: classes.version
      }, version));
    }
  }]);

  return Sidebar;
}(React.Component);

export default withStyles(styles, {
  name: 'Sidebar'
})(Sidebar);